import React from "react";
import { Parallax } from "react-scroll-parallax";
import './Universe.css';

const UniverseSection = () => {
  return (
    <Parallax
      className="universe-section"
      speed={-10}
    >
      <div
        id="home" // Existing ID for scrolling
        className="universe-content"
        style={{
          backgroundImage: "url('/Universe.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        <h1>Welcome to UniVerse</h1>
        <p>Experience the future of education with AI-powered solutions.</p>
      </div>
    </Parallax>
  );
};

export default UniverseSection;
